import ButtonV2 from './ButtonV2.vue';
import CheckboxV2 from './CheckboxV2.vue';
import CopyFieldV2 from './CopyFieldV2.vue';
import DropdownV2 from './DropdownV2.vue';
import FormFieldV2 from './FormFieldV2.vue';
import InputV2 from './InputV2.vue';
import ModalFooterV2 from './ModalFooterV2.vue';
import ModalV2 from './ModalV2.vue';
import PhoneInputV2 from './PhoneInputV2.vue';
import SelectV2 from './SelectV2.vue';
import SwitchV2 from './SwitchV2.vue';
import TagV2 from './TagV2.vue';

export const V2_COMPONENTS = {
  'button-v2': ButtonV2,
  'checkbox-v2': CheckboxV2,
  'copy-field-v2': CopyFieldV2,
  'dropdown-v2': DropdownV2,
  'form-field-v2': FormFieldV2,
  'input-v2': InputV2,
  'modal-footer-v2': ModalFooterV2,
  'modal-v2': ModalV2,
  'phone-input-v2': PhoneInputV2,
  'select-v2': SelectV2,
  'switch-v2': SwitchV2,
  'tag-v2': TagV2,
};

export {
  ButtonV2,
  CheckboxV2,
  CopyFieldV2,
  DropdownV2,
  FormFieldV2,
  InputV2,
  ModalFooterV2,
  ModalV2,
  PhoneInputV2,
  SelectV2,
  SwitchV2,
  TagV2,
};

export default {
  install(Vue) {
    Object.entries(V2_COMPONENTS).forEach(([name, component]) => {
      Vue.component(name, component);
    });
  },
};
